// extracted by mini-css-extract-plugin
module.exports = {"tab":"ChatGPTPopup_tab__UdjEU","tabItem":"ChatGPTPopup_tabItem__VljLN","top":"ChatGPTPopup_top__ieYZ5","colse":"ChatGPTPopup_colse__hqR3f"};